module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/fecad7da66ad4cdf1942253998bdc4bc.png";